import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgIncreasePriceUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.058 3 .48 12.028C-.54 13.242.405 15 2.076 15H14.04c1.671 0 2.616-1.758 1.597-2.972L8.058 3Z"
      fill="#D0021B"
    />
  </svg>
);
const Memo = memo(SvgIncreasePriceUp);
export default Memo;
